(() => { document.querySelectorAll('[data-anya-product]').forEach(product => {
const slides=[...product.querySelectorAll('[data-product-slide]')];
const thumbs=[...product.querySelectorAll('[data-gallery-thumb]')];
const counter=product.querySelector('[data-gallery-counter]');
let activeIndex=Math.max(0,slides.findIndex(s=>s.classList.contains('is-active')));
    const showSlide = (index) => {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === activeIndex);
        slide.setAttribute('aria-hidden', String(i !== activeIndex));
      });
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === activeIndex));
      if (counter) counter.textContent = `${activeIndex + 1} / ${slides.length}`;
      
    };


thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>showSlide(i)));
product.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>showSlide(activeIndex-1));
product.querySelector('[data-gallery-next]')?.addEventListener('click',()=>showSlide(activeIndex+1));
showSlide(activeIndex);
}); })();
